import './navigation.css';
import ProfileIcon from '../../images/profile-icon.svg';
import ResetChatIcon from '../../images/reset-chat-icon.svg';
import ClearChatIcon from '../../images/clear-chat-icon.svg';
import ConnectIcon from '../../images/connect-icon.svg';
import LogoutIcon from '../../images/logout-icon.svg';
import apiCall from '../../utils/api';
import trackEvent from '../../utils/analytics.js';
import FeedbackIcon from '../../images/feedback-icon.svg';
import ToggleOff from '../../images/toggle-off.svg';
import ToggleOn from '../../images/toggle-on.svg';
import whatsAppIcon from '../../images/whatsapp-icon.svg';
import { useEffect, useState } from 'react';


const Navigation = ({ setShowProfile, openModal, setIsLoading, darkMode, toggleDarkMode, setShowNavMenu, selectedCharacter, setMessages, fetchChatHistory, handleReportContent }) => {
    const [appVersion, setAppVersion] = useState(null);

    // Helper function to check if version is 3.0.0 or higher
    const isVersion3OrHigher = (version) => {
        if (!version) return false;
        
        // Split version string by dots and convert to numbers
        const versionParts = version.split('.').map(part => parseInt(part, 10));
        
        // Check if major version is 3 or higher
        return versionParts[0] >= 3;
    };

    // Extract app version from URL parameters
    useEffect(() => {
        const urlObj = new URL(window.location.href);
        const params = new URLSearchParams(urlObj.search);
        const version = params.get('app_version');
        setAppVersion(version);
    }, []);

    const handleResetChat = async () => {
        try {
            setIsLoading(true);
            const queryParams = new URLSearchParams({
                character_id: selectedCharacter?._id
            });
            await apiCall.get('/chat/reset?' + queryParams.toString());
            // Clear messages and refetch chat history instead of reloading page
            setMessages([]);
            await fetchChatHistory();
        } catch (error) {
            console.error('Failed to reset chat:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClearChat = async () => {
        try {
            setIsLoading(true);
            const queryParams = new URLSearchParams({
                character_id: selectedCharacter?._id
            });
            await apiCall.get('/chat/clear?' + queryParams.toString());
            // Clear messages and refetch chat history instead of reloading page
            setMessages([]);
            await fetchChatHistory();
        } catch (error) {
            console.error('Failed to clear chat:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggleDarkMode = () => {
        trackEvent('dark_mode_toggled');
        toggleDarkMode();
    };


    const logOut = () => {
        trackEvent('logout_clicked');
        document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        try {
            onLogoutAndroid()
        }
        catch { };
        window.location.reload();
    }

    function onLogoutAndroid() {
        console.log("Android sign out triggered");
        window.AndroidBridge.triggerLogout();
    }

    const collectFeedback = () => {
        trackEvent('feedback_clicked');
        window.open('https://www.chaimate.ai/contact-us', '_blank');
    };

    const onJoinCommunityClicked = () => {
        trackEvent('join_community_clicked');
        setShowNavMenu(false);
        try {
            window.AndroidBridge.openDeeplink('https://wa.me/918209561672');
        } catch (error) {
            // Fallback to regular window.open if Android bridge is not available
            window.open('https://wa.me/918209561672', '_blank');
        }
    }


    return (
        <>
            <div className='navigation-menu-container' onClick={e => e.stopPropagation()}>
                {/* <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer' }} onClick={() => { trackEvent('profile_clicked'); setShowProfile(true); setShowNavMenu(false); }} >
                    <img src={ProfileIcon} className='navigation-menu-icon' />
                    <span>Customize Dia</span>
                </div> */}
                <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer' }} onClick={() => { trackEvent('reset_chat_clicked'); openModal('Reset Chat', 'Messages and memories will be erased permanently. This action is irreversible.', handleResetChat); setShowNavMenu(false); }}>
                    <img src={ResetChatIcon} className='navigation-menu-icon' />
                    <span>Erase all data</span>
                </div>
                <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer' }} onClick={() => { trackEvent('clear_chat_clicked'); openModal('Clear Chat', 'Clear the visible chat without affecting memory or conversation history.', handleClearChat); setShowNavMenu(false); }}>
                    <img src={ClearChatIcon} className='navigation-menu-icon' />
                    <span>Clear chat</span>
                </div>
                {/* <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer', filter: 'none' }} onClick={() => { handleToggleDarkMode(); setShowNavMenu(false); }}>
                    <img src={darkMode ? ToggleOn : ToggleOff} className="navigation-menu-icon" style={{filter: 'none'}}/>
                    <span>Switch to {darkMode ?  'Light' :'Dark'} Mode</span>
                </div> */}
                {/* <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer'}} onClick={() => { collectFeedback(); setShowNavMenu(false); }}>
                    <img src={FeedbackIcon} className="navigation-menu-icon" />
                    <span>Give us Feedback</span>
                </div> */}
                <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', cursor: 'pointer' }} onClick={handleReportContent}>
                    <img src={FeedbackIcon} className='navigation-menu-icon' />
                    <span>Report Content</span>
                </div>
                {isVersion3OrHigher(appVersion) && (
                    <>
                        <div className='navigation-menu-divider' />
                        <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', borderBottom: 'none', cursor: 'pointer' }} onClick={onJoinCommunityClicked}>
                            <img src={whatsAppIcon} className='navigation-menu-icon' style={{filter: 'none'}} />
                            <span>Contact Support</span>
                        </div>
                    </>
                )}
                <div className='navigation-menu-divider' />
                <div className='navigation-menu-text' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', borderBottom: 'none', cursor: 'pointer' }} onClick={() => { logOut(); setShowNavMenu(false); }}>
                    <img src={LogoutIcon} className='navigation-menu-icon' />
                    <span>Logout</span>
                </div>
            </div>
        </>
    )
}

export default Navigation;